import { withInstall } from "@xplus/utils/with-install";
import tree from "./src/tree.vue";
export const xTree = withInstall(tree);
export default xTree;
